import { render, staticRenderFns } from "./ShopInstructions.vue?vue&type=template&id=45622a8d&scoped=true&"
import script from "./ShopInstructions.vue?vue&type=script&lang=js&"
export * from "./ShopInstructions.vue?vue&type=script&lang=js&"
import style0 from "./ShopInstructions.vue?vue&type=style&index=0&id=45622a8d&lang=scss&scoped=true&"
import style1 from "./ShopInstructions.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45622a8d",
  null
  
)

export default component.exports